import { Handle, Position } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import styles from "./nodes.module.css"

const End = ({ data, selected, dragging, className }) => {
    return (
        <div className={`${styles.node} ${selected ? styles.selected : ''} ${dragging ? styles.dragging : ''} ${className}`}>
            <span>{data.label}</span>
            <Handle type="source" position={Position.Top} />
        </div>
    )
}

export default End